import { IntegrityMonitorCustomRuleMainFormWebComponent } from '../../imCustomRuleMainForm';
import { WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_MAIN_FORM } from '../../../../../webcomponents.constants';
import { BaseWebComponentView } from '../../../../../framework/BaseWebComponentView';
import { GzButtonWebComponent } from '../../../../../ui/gzButton';
import { Rights } from '@nirvana/shared/constants';

export class IntegrityMonitorAddCustomRulePanelView extends BaseWebComponentView {
  public successfulSaveMessage = '';
  public successfulUpdateMessage = '';

  public dom: {
    $ruleForm: IntegrityMonitorCustomRuleMainFormWebComponent;

    $saveButton: GzButtonWebComponent;
    $cancelButton: GzButtonWebComponent;
  };

  getDomElements() {
    this.dom = {
      $ruleForm: this.shadow.querySelector(WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_MAIN_FORM),

      $saveButton: this.shadow.querySelector('#save-button'),
      $cancelButton: this.shadow.querySelector('#cancel-button'),
    };

    this.dom.$saveButton.disabled = true;

    this.getTranslations();
    this.setTranslatedStrings();
  }

  getTranslations() {
    this.commonStrings = this.stringsTranslator.getCommonStrings();
    this.translations = this.stringsTranslator.getIntegrityMonitorStrings().integrityMonitorRules.customRuleForm;
    this.successfulSaveMessage = this.translations.successfulSave;
    this.successfulUpdateMessage = this.translations.successfulUpdate;
  }

  setTranslatedStrings() {
    this.dom.$saveButton.innerHTML = this.translations.save;
    this.dom.$cancelButton.innerHTML = this.commonStrings.cancel;
  }

  buildSuccessView(data: any) {
    this.dom.$saveButton.disabled = false;

    this.dom.$ruleForm.injectDependencies(this.dependencies);
    this.dom.$ruleForm
      .start()
      .catch(console.warn)
      .then(() => {
        const disabled = !Application.Main.hasAllRights([Rights.MANAGE_POLICIES_WRITE]);
        this.dom.$ruleForm.valid$.subscribe(valid => {
          this.dom.$saveButton.disabled = !valid || disabled;
        });
      });

    this.handleFooterButtons();
    this.dom.$saveButton.disabled = this.dom.$saveButton.disabled || !Application.Main.hasAllRights([Rights.MANAGE_POLICIES_WRITE]);

  }

  buildErrorView(error: any) {
    this.dom.$saveButton.disabled = true;
  }

  private handleFooterButtons(): void {
    if (this.dependencies.canModifyRulesAndRuleSets()) {
      this.dom.$saveButton.classList.remove('hidden');
      this.dom.$cancelButton.textContent = this.commonStrings.cancel;
    } else {
      this.dom.$saveButton.classList.add('hidden');
      this.dom.$cancelButton.textContent = this.commonStrings.close;
    }
  }
}
